window.addEventListener("scroll", function () {
  const fvHeight = document.querySelector(".fv").offsetHeight;
  const header = document.querySelector(".or__header");

  if (window.scrollY > fvHeight) {
    header.classList.add("is_fixed");
  } else {
    header.classList.remove("is_fixed");
  }
});

const fv__slider = new Swiper(".fv__slider", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  speed: 2000,
  autoplay: {
    delay: 5000, // 3秒ごとに自動スライド
    disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
  },
    effect: 'fade', 
    fadeEffect: {
    crossFade: true
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
  },
});
